import script from "./ViewLinkPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLinkPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewLinkPaymentVoucherPage.vue?vue&type=style&index=0&id=ba4032a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba4032a8"]])

export default __exports__